import Outcome from '@/api/outcome'

export default {
  fetchPerPage: ({ commit, getters, rootState }, { page = 1 }) => {
    commit('changeLoading', { isLoading: true })
    return Outcome.fetchAll({ page })
      .then(({ data, pagination }) => {
        commit('collectionForPageFetched', {
          collectionForPage: data,
          pagination,
          scope: { page }
        })
        commit('changeLoading', { isLoading: false })
      })
      .catch(error => {
        commit('changeLoading', { isLoading: false })
        throw error
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/skiliko/outcomes/actions.js